<template>
    <div id="container">
        <Spinner :show="loading"></Spinner>
        <Header></Header>
        <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
        <section ref="content" id="content" class="section has-text-centered relative">
            <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
            <div class="columns is-mobile is-centered">
                <div class="column is-two-thirds has-text-centered">
                    <a @click="$router.push('/households/register')" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-home"></i>
                        </span>
                        <span>{{ $t("RegisterHousehold") }}</span>
                    </a>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column is-two-thirds has-text-centered">
                    <a @click="$router.push('/households/search')" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-search"></i>
                        </span>
                        <span>{{ $t("SearchHousehold") }}</span>
                    </a>
                </div>
            </div>
        </section>
        <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "Households",
  components: {
    Header,
    Modal,
    Notification,
    NavigationTabs,
    Spinner
  },
  data()
  {
    return {
        modal: {
              title: null,
              body: null,
              centerBody: true,
              className: "",
              buttons:
              [
                {id: 0, title: this.$t("OK"), className: "is-info", click: () => { this.modal.className = ""; }}
              ]
          }
    }
  }
};
</script>
